import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SPCandidateHistorySchedulingNcarbExamAuthFormLocType } from '../ncarb-exam-auth-form/ncarb-exam-auth-form.locs';

export const ncarbSchedulingPathStart = 'Candidate|Scheduling|Scheduling|';
export const ncarbSchedulingSharedProperties: Pick<
	LocDef,
	'shared' | 'htmlAllowed' | 'feature' | 'portal'
> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSchedulingNcarbAuthorizationDetail,
	portal: 'SP',
};

export type SPCandidateHistorySchedulingNcarbExamAuthAddLocNames =
	| 'SPCandidateHistorySchedulingNcarbExamAuthAddTitle'
	| 'SPCandidateHistorySchedulingNcarbExamAuthAddButton'
	| 'SPCandidateHistorySchedulingNcarbExamAuthAddCancelButton';

export const spCandidateHistorySchedulingNcarbExamAuthAddLocs: LocDefs<SPCandidateHistorySchedulingNcarbExamAuthAddLocNames> =
	{
		SPCandidateHistorySchedulingNcarbExamAuthAddTitle: {
			defaultValue: 'Add Authorization',
			description: 'Dialog title for the add authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Add Authorization|Dialog Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthAddButton: {
			defaultValue: 'Save Authorization',
			description: 'Button to add the authorization.',
			displayPath: `${ncarbSchedulingPathStart}Add Authorization|Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthAddCancelButton: {
			defaultValue: 'Cancel',
			description: 'Button to cancel the add authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Add Authorization|Cancel Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbExamAuthAddLocType =
	LocMap<SPCandidateHistorySchedulingNcarbExamAuthAddLocNames> &
		SPCandidateHistorySchedulingNcarbExamAuthFormLocType;
